import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApiError } from "@porchpass/api-client";
import { createDealerDomain } from "src/api/domains/dealer";

type UseDealershipDataFunc = () => {
  logoUrl: string;
  linkUrl: string;
  phoneNumber: string;
  email: string;
  dealerId: string;
};

export const useDealershipData: UseDealershipDataFunc = () => {
  const { dealerName } = useParams();
  const navigate = useNavigate();
  const [logoUrl, setLogoUrl] = useState<string>("");
  const [linkUrl, setLinkUrl] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [dealerId, setDealerId] = useState<string>("");
  const dealerApi = useMemo(
    () => createDealerDomain(dealerName ?? ""),
    [dealerName],
  );

  useEffect(() => {
    if (!dealerName) return;

    void dealerApi
      .getDealer(dealerName)
      .then((data) => {
        setLogoUrl(data.logo_url ?? "");
        setLinkUrl(data.website_url ?? "");
        setPhoneNumber(data.phone_number ?? "");
        setEmail(data.email ?? "");
        setDealerId(data.id ?? "");
      })
      .catch((err) => {
        if (err instanceof ApiError && err.status === 404) {
          navigate("/not-found", { replace: true });
          return;
        }
        console.error(err);
      });
  }, [dealerApi, dealerName, navigate]);

  return {
    logoUrl,
    linkUrl,
    phoneNumber,
    email,
    dealerId,
  };
};
